import "./Inquiries.module.css";
import StudioThorneHeader from "@/reusable_sections/Header";
import CollaborateWithThorne from "./sections/CollaborateWithThorne";
import GlobalPresence from "./sections/GlobalPresence";
import StudioThorneFooter from "@/reusable_sections/Footer";
export default function InquiriesPage() {
  return <div>
      <StudioThorneHeader />
      <CollaborateWithThorne />
      <GlobalPresence />
      <StudioThorneFooter />
    </div>;
}